import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { MPageComponent } from './page-picker.component';
import { MPagePickerService } from './page-picker.service';

@NgModule({
  imports: [CommonModule, FormsModule, NzRadioModule, NzDividerModule, NzGridModule, NzInputModule, NzPopoverModule, NzButtonModule],
  declarations: [MPageComponent],
  exports: [MPageComponent],
  providers: [MPagePickerService]
})
export class MPagePickerModule {}
